/**
 * Cookie preferences trigger.
 *
 * Opens Shopify's own privacy preference centre via window.privacyBanner.showPreferences(),
 * so the choice the visitor makes is the consent Shopify, the pixels and the apps actually
 * read. Re-opening it is how a visitor withdraws consent they gave earlier.
 *
 * The banner script loads asynchronously, so the trigger stays usable before the API is
 * ready: it retries, and falls back to the privacy policy page if the API never arrives.
 */
(function () {
  'use strict';

  var TRIGGER = '[data-cookie-preferences]';

  function banner() {
    var b = window.privacyBanner;
    return b && typeof b.showPreferences === 'function' ? b : null;
  }

  function customerPrivacy() {
    var shopify = window.Shopify;
    return shopify && shopify.customerPrivacy ? shopify.customerPrivacy : null;
  }

  function openPreferences() {
    var b = banner();
    if (!b) return false;
    try {
      b.showPreferences();
      return true;
    } catch (e) {
      return false;
    }
  }

  function handleClick(event) {
    if (openPreferences()) {
      event.preventDefault();
      return;
    }

    // The API may not have finished loading. Ask it to load, then try once more.
    var b = window.privacyBanner;
    if (b && typeof b.loadBanner === 'function') {
      try {
        b.loadBanner();
      } catch (e) {
        /* ignore — the link falls through to its href below */
      }
      if (openPreferences()) {
        event.preventDefault();
        return;
      }
    }

    // No preference centre available: let the link follow its href (the privacy policy).
  }

  /** 'all' | 'essential' | 'custom' | null when the visitor has not chosen yet. */
  function consentState() {
    var privacy = customerPrivacy();
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return null;

    var consent;
    try {
      consent = privacy.currentVisitorConsent();
    } catch (e) {
      return null;
    }
    if (!consent) return null;

    var keys = ['analytics', 'marketing', 'preferences'];
    var answered = keys.filter(function (key) {
      return consent[key] === 'yes' || consent[key] === 'no';
    });
    if (!answered.length) return null;

    var allowed = keys.filter(function (key) {
      return consent[key] === 'yes';
    });
    if (allowed.length === keys.length) return 'all';
    if (!allowed.length) return 'essential';
    return 'custom';
  }

  function renderState(trigger) {
    var el = trigger.querySelector('[data-cookie-preferences-state]');
    if (!el) return;

    var state = consentState();
    if (!state) {
      el.removeAttribute('data-state');
      el.textContent = '';
      return;
    }

    var label = el.getAttribute('data-label-' + state);
    if (!label) {
      el.removeAttribute('data-state');
      el.textContent = '';
      return;
    }

    el.setAttribute('data-state', state);
    el.textContent = label;
  }

  function renderAll() {
    Array.prototype.forEach.call(document.querySelectorAll(TRIGGER), renderState);
  }

  function init() {
    var triggers = document.querySelectorAll(TRIGGER);
    if (!triggers.length) return;

    Array.prototype.forEach.call(triggers, function (trigger) {
      if (trigger.dataset.cookiePreferencesBound === 'true') return;
      trigger.dataset.cookiePreferencesBound = 'true';
      trigger.addEventListener('click', handleClick);
    });

    renderAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The consent API loads after the page, and the state changes when the visitor saves.
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', renderAll);
  document.addEventListener('visitorConsentCollected', renderAll);
})();
